// Module
var code = `<section class="page-body default-content">

  <h2>Lists</h2>
  <p>
    Lists provide structured groupings of content. SpyneJS styles unordered (<code>&lt;ul&gt;</code>),
    ordered (<code>&lt;ol&gt;</code>), and description lists (<code>&lt;dl&gt;</code>)
    with consistent spacing, typography, and alignment.
  </p>

  <!-- Unordered List -->
  <h3>Unordered List</h3>
  <p>
    Unordered lists (<code>&lt;ul&gt;</code>) use disc bullets by default, with consistent spacing
    defined by the design system’s spacing scale.
  </p>
  <div class="list-examples">
    <ul>
      <li>First unordered item</li>
      <li>Second unordered item</li>
      <li>Third unordered item</li>
    </ul>
  </div>
  <div class="codeblock">
    <div class="codeblock__header">
      <button class="codeblock__copy" data-copy-btn>Copy</button>
    </div>
    <pre><code class="language-html">
&lt;ul&gt;
  &lt;li&gt;First unordered item&lt;/li&gt;
  &lt;li&gt;Second unordered item&lt;/li&gt;
  &lt;li&gt;Third unordered item&lt;/li&gt;
&lt;/ul&gt;
    </code></pre>
  </div>

  <!-- Ordered List -->
  <h3>Ordered List</h3>
  <p>
    Ordered lists (<code>&lt;ol&gt;</code>) are styled with decimal markers and consistent vertical spacing.
  </p>
  <div class="list-examples">
    <ol>
      <li>First ordered item</li>
      <li>Second ordered item</li>
      <li>Third ordered item</li>
    </ol>
  </div>
  <div class="codeblock">
    <div class="codeblock__header">
      <button class="codeblock__copy" data-copy-btn>Copy</button>
    </div>
    <pre><code class="language-html">
&lt;ol&gt;
  &lt;li&gt;First ordered item&lt;/li&gt;
  &lt;li&gt;Second ordered item&lt;/li&gt;
  &lt;li&gt;Third ordered item&lt;/li&gt;
&lt;/ol&gt;
    </code></pre>
  </div>

  <!-- Description List -->
  <h3>Description List</h3>
  <p>
    Description lists (<code>&lt;dl&gt;</code>) are styled for term/definition pairs.
    Terms (<code>&lt;dt&gt;</code>) use semibold weight, and definitions (<code>&lt;dd&gt;</code>)
    are indented for clarity.
  </p>
  <div class="list-examples">
    <dl>
      <dt>Term One</dt>
      <dd>Definition for term one.</dd>
      <dt>Term Two</dt>
      <dd>Definition for term two.</dd>
    </dl>
  </div>
  <div class="codeblock">
    <div class="codeblock__header">
      <button class="codeblock__copy" data-copy-btn>Copy</button>
    </div>
    <pre><code class="language-html">
&lt;dl&gt;
  &lt;dt&gt;Term One&lt;/dt&gt;
  &lt;dd&gt;Definition for term one.&lt;/dd&gt;
  &lt;dt&gt;Term Two&lt;/dt&gt;
  &lt;dd&gt;Definition for term two.&lt;/dd&gt;
&lt;/dl&gt;
    </code></pre>
  </div>

  <!-- Prefixed Lists -->
  <h3>Prefixed Lists (Plugins)</h3>
  <p>
    Plugins can scope lists using prefixed classes (e.g. <code>.devtool-list</code>) to avoid
    style collisions with the host application.
  </p>
  <div class="list-examples">
    <div class="devtool-list">
      <ul>
        <li>Plugin-scoped list item</li>
        <li>Another plugin item</li>
      </ul>
    </div>
  </div>
  <div class="codeblock">
    <div class="codeblock__header">
      <button class="codeblock__copy" data-copy-btn>Copy</button>
    </div>
    <pre><code class="language-html">
&lt;div class="devtool-list"&gt;
  &lt;ul&gt;
    &lt;li&gt;Plugin-scoped list item&lt;/li&gt;
    &lt;li&gt;Another plugin item&lt;/li&gt;
  &lt;/ul&gt;
&lt;/div&gt;
    </code></pre>
  </div>

  <!-- Accessibility -->
  <h3>Accessibility</h3>
  <ul>
    <li>Use unordered lists for non-sequential items.</li>
    <li>Use ordered lists when order or steps matter.</li>
    <li>Use description lists for term–definition pairs (like glossaries or FAQs).</li>
    <li>Always use semantic list elements instead of manually styled divs for screen reader support.</li>
  </ul>

</section>
`;
// Exports
module.exports = code;